var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _line, _path3, _rect7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssueStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 210,
    viewBox: "0 0 217 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211.008,
    height: 125.697,
    rx: 11.5013,
    transform: "matrix(1 0 0 -1 5.49219 160.371)",
    fill: "#82ADF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49219 132.236L216.5 132.236V46.1748C216.5 39.8228 211.351 34.6735 204.999 34.6735L16.9935 34.6735C10.6415 34.6735 5.49219 39.8228 5.49219 46.1748L5.49219 132.236Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43767,
    y: -1.43767,
    width: 208.133,
    height: 122.822,
    rx: 10.0637,
    transform: "matrix(1 0 0 -1 0.5 151.596)",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1382,
    y: 195.765,
    width: 116.168,
    height: 14.0672,
    rx: 5.75067,
    fill: "#82ADF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.735 157.648H94.0733C92.8047 157.648 91.6859 158.479 91.3201 159.694L79.9111 197.58H142.306L130.735 157.648Z",
    fill: "#82ADF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 13.6592 45.563)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 28.0605 45.563)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 42.4639 45.563)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 133.067,
    x2: 211.508,
    y2: 133.067,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.743 153.564H89.0816C87.813 153.564 86.6942 154.395 86.3284 155.61L74.9194 193.497H137.314L125.743 153.564Z",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5842,
    y: 194.027,
    width: 113.293,
    height: 11.1919,
    rx: 4.313,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2093_55957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 56.6666H102.333L85.3902 73.6666L85.3335 107.667C85.3335 110.783 87.8835 113.333 91.0002 113.333H125C128.117 113.333 130.667 110.783 130.667 107.667V62.3333C130.667 59.2166 128.117 56.6666 125 56.6666ZM125 107.667H91.0002V76.0183L104.685 62.3333H125V107.667ZM105.167 93.5H110.833V99.1666H105.167V93.5ZM105.167 73.6666H110.833V87.8333H105.167V73.6666Z",
    fill: "#82ADF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2093_55957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(74 51)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueStatus);
export default __webpack_public_path__ + "static/media/issueStatus.ed9494c3.svg";
export { ForwardRef as ReactComponent };